import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import AuthForm from '../components/AuthForm.js';
import { GOLD } from '../constants/colors.js';

export default function AuthPage() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #181818 60%, #232323 100%)',
      }}
    >
      <Paper
        elevation={8}
        sx={{
          p: { xs: 3, sm: 5 },
          minWidth: { xs: 320, sm: 400 },
          maxWidth: 420,
          borderRadius: 4,
          background: 'rgba(32,32,32,0.90)',
          boxShadow: '0 8px 32px 0 rgba(0,0,0,0.30)',
          backdropFilter: 'blur(12px)',
          border: `1.5px solid ${GOLD}33`,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="h4"
          align="center"
          sx={{
            fontWeight: 900,
            color: GOLD,
            letterSpacing: 2,
            mb: 2,
            textShadow: '0 2px 12px #0008',
          }}
        >
          FARZL Industrial
        </Typography>
        <Typography
          variant="subtitle1"
          align="center"
          sx={{ color: 'text.secondary', mb: 3 }}
        >
          Sign in to continue
        </Typography>
        <AuthForm />
      </Paper>
    </Box>
  );
}
